import { render, staticRenderFns } from "./MdtecPanel.vue?vue&type=template&id=131b17aa&scoped=true"
import script from "./MdtecPanel.vue?vue&type=script&lang=js"
export * from "./MdtecPanel.vue?vue&type=script&lang=js"
import style0 from "./MdtecPanel.vue?vue&type=style&index=0&id=131b17aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b17aa",
  null
  
)

export default component.exports